import { useState } from "react";
import classNames from "classnames";

import {
  AuthUserRole,
  appConfig,
  translate,
  useAuthContext,
} from "@ascendnow/shared";

import AscModalClassic from "../AscModalClassic/AscModalClassic";
import AscDropdown from "../AscDropdown/AscDropdown";
import styles from "./AscTopNavAdmin.module.scss";
import AscMenuIconButton from "../AscButton/AscMenuIconButton/AscMenuIconButton";
// import AscToogleBox from "../AscInputFields/AscToogleBox/AscToogleBox";
import AscAdminProfileDropdown from "../AscAdminProfileDropdown/AscAdminProfileDropdown";
import AscAdminNotificationDrawer from "../AscAdminNotificationDrawer/AscAdminNotificationDrawer";

export interface AscTopNavAdminProps {
  className?: string;
  pageName?: string;
  title?: string;
  subTitle?: string;
  notificationsCount?: number;
  avatarUrl: any;
  name: string;
  schoolName?: string;
  contained?: boolean;
  onClickProfile?: () => void;
  onClickHelp?: () => void;
  onClickLogOut?: () => void;
  role?: AuthUserRole;
  schoolStuffCredits?: number;
  teacherStuffCredits?: number;
}

export default function AscTopNavAdmin({
  className,
  pageName,
  title,
  subTitle,
  notificationsCount = 0,
  avatarUrl,
  name,
  schoolName,
  contained,
  onClickProfile,
  onClickHelp,
  onClickLogOut,
  role,
  schoolStuffCredits,
  teacherStuffCredits,
}: AscTopNavAdminProps) {
  const [confirmLogout, setConfirmLogout] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const { logout } = useAuthContext();

  const handleLogout = () => {
    logout();
    onClickLogOut?.();
  };

  return (
    <>
      <nav
        data-testid="asc-top-navigation"
        className={classNames(
          styles.ground,
          {
            [styles.contained]: contained,
          },
          className
        )}
      >
        <div
          className={classNames(styles.leftContent, {
            [styles.withPageName]: pageName,
          })}
        >
          <div className={styles.titleContainer}>
            <h3 className={styles.pageName}>{pageName}</h3>
            {role !== appConfig.role.ADMIN &&
              schoolStuffCredits !== undefined &&
              schoolStuffCredits !== null && (
                <p className={styles.credits}>
                  {schoolStuffCredits} credits
                  <span className={styles.subTitle}> available</span>
                </p>
              )}
            {teacherStuffCredits !== undefined &&
              teacherStuffCredits !== null && (
                <p className={styles.credits}>
                  {teacherStuffCredits} credits{" "}
                  <span className={styles.subTitle}> available</span>
                </p>
              )}
            <p className={styles.title}>
              {title}{" "}
              <span className={classNames(styles.title, styles.subTitle)}>
                {subTitle}
              </span>
            </p>
          </div>
        </div>

        <div className={styles.rightContent}>
          {/* <div className={styles.viewContent}>
          <h5 className={styles.viewText}>Student view</h5>
          <AscToogleBox />
        </div> */}

          {role !== appConfig.role.ADMIN && role !== appConfig.role.PARENT ? (
            <>
              <AscMenuIconButton
                className={classNames(styles.notificationButton)}
                count={notificationsCount}
                onClick={() => setShowNotifications((prev) => !prev)}
              />
              <AscAdminNotificationDrawer
                setVisible={setShowNotifications}
                visible={showNotifications}
              />
            </>
          ) : null}

          <AscAdminProfileDropdown
            avatarUrl={avatarUrl}
            name={name}
            schoolName={schoolName}
            className={styles.userDropdown}
          >
            <AscDropdown.Option onClick={onClickProfile}>
              {translate("profile")}
            </AscDropdown.Option>
            <AscDropdown.Option onClick={onClickHelp}>
              {translate("help")}
            </AscDropdown.Option>
            <AscDropdown.Option onClick={() => setConfirmLogout(true)}>
              {translate("logout")}
            </AscDropdown.Option>
          </AscAdminProfileDropdown>
        </div>
      </nav>
      {confirmLogout && (
        <AscModalClassic
          visible={confirmLogout}
          setVisible={setConfirmLogout}
          icon="question-mark"
          type="cancel-and-confirm"
          title="Do you want to Log Out?"
          description="Are you sure that you want to Log Out?"
          confirmButtonAction={handleLogout}
        />
      )}
    </>
  );
}
